(function () {
  var MAX_VISIBLE_THUMBS = 4;
  var galleriesState = new WeakMap();

  function getThumbItems(thumbnails) {
    return Array.prototype.slice.call(thumbnails.querySelectorAll('[data-target]'));
  }

  function getMediaItems(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    return viewer ? Array.prototype.slice.call(viewer.querySelectorAll('[data-media-id]')) : [];
  }

  function getNavigableThumbItems(gallery) {
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!thumbnails || !viewer) return [];
    return getThumbItems(thumbnails).filter(function (thumb) {
      var mediaId = thumb.getAttribute('data-target');
      var media = mediaId ? viewer.querySelector('[data-media-id="' + mediaId + '"]') : null;
      return !!(media && getMediaImage(media));
    });
  }

  function getNavigableMediaItems(gallery) {
    var thumbs = getNavigableThumbItems(gallery);
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (thumbs.length && viewer) {
      return thumbs.map(function (thumb) {
        return viewer.querySelector('[data-media-id="' + thumb.getAttribute('data-target') + '"]');
      }).filter(Boolean);
    }
    return getMediaItems(gallery).filter(function (item) { return !!getMediaImage(item); });
  }


  function getCurrentStart(thumbnails) {
    var value = parseInt(thumbnails.getAttribute('data-s2g-thumb-start') || '0', 10);
    return Number.isFinite(value) ? value : 0;
  }

  function setCurrentStart(thumbnails, value) {
    thumbnails.setAttribute('data-s2g-thumb-start', String(value));
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function updateThumbnailWindow(thumbnails, preferredStart) {
    if (!thumbnails) return;

    var items = getThumbItems(thumbnails);
    var prevButton = thumbnails.querySelector('.slider-button--prev');
    var nextButton = thumbnails.querySelector('.slider-button--next');
    var maxStart = Math.max(0, items.length - MAX_VISIBLE_THUMBS);
    var start = typeof preferredStart === 'number' ? preferredStart : getCurrentStart(thumbnails);

    start = Math.max(0, Math.min(start, maxStart));
    setCurrentStart(thumbnails, start);

    thumbnails.classList.add('s2g-thumbnail-pager');
    thumbnails.classList.toggle('s2g-thumbnail-pager--has-arrows', items.length > MAX_VISIBLE_THUMBS);
    thumbnails.classList.toggle('s2g-thumbnail-pager--no-arrows', items.length <= MAX_VISIBLE_THUMBS);

    items.forEach(function (item, index) {
      var visible = isMobile() || items.length <= MAX_VISIBLE_THUMBS || (index >= start && index < start + MAX_VISIBLE_THUMBS);
      item.classList.toggle('s2g-thumb-hidden', !visible);
      item.style.display = visible ? 'block' : 'none';
      item.style.visibility = visible ? 'visible' : 'hidden';
      item.style.opacity = visible ? '1' : '0';
    });

    [prevButton, nextButton].forEach(function (button) {
      if (!button) return;
      button.disabled = false;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.tabIndex = 0;
      button.style.pointerEvents = items.length > MAX_VISIBLE_THUMBS ? 'auto' : 'none';
    });

    if (prevButton) {
      var hidePrev = isMobile() || items.length <= MAX_VISIBLE_THUMBS || start <= 0;
      prevButton.hidden = hidePrev;
      prevButton.style.display = hidePrev ? 'none' : 'flex';
    }

    if (nextButton) {
      var hideNext = isMobile() || items.length <= MAX_VISIBLE_THUMBS || start >= maxStart;
      nextButton.hidden = hideNext;
      nextButton.style.display = hideNext ? 'none' : 'flex';
    }
  }

  function getActiveIndex(gallery) {
    var navigableItems = getNavigableMediaItems(gallery);
    var allItems = getMediaItems(gallery);
    var activeMedia = allItems.find(function (item) {
      return item.classList.contains('is-active') || item.style.display === 'block';
    });

    if (activeMedia && navigableItems.length) {
      var activeIndex = navigableItems.indexOf(activeMedia);
      if (activeIndex > -1) return activeIndex;
    }

    var stored = parseInt(gallery.getAttribute('data-s2g-active-index') || '0', 10);
    if (Number.isFinite(stored) && stored >= 0 && stored < navigableItems.length) return stored;
    return 0;
  }

  function showThumbnailIndex(thumbnails, index) {
    var items = getThumbItems(thumbnails);
    if (!items.length) return;

    var start = getCurrentStart(thumbnails);
    if (index < start) start = index;
    if (index >= start + MAX_VISIBLE_THUMBS) start = index - MAX_VISIBLE_THUMBS + 1;
    updateThumbnailWindow(thumbnails, start);

    if (isMobile()) {
      var activeItem = items[index];
      if (activeItem && activeItem.scrollIntoView) {
        activeItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
  }

  function updateMobileNav(gallery) {
    var nav = gallery.querySelector('.s2g-mobile-gallery-nav');
    if (!nav) return;
    var mediaItems = getNavigableMediaItems(gallery);
    var activeIndex = getActiveIndex(gallery);
    var prev = nav.querySelector('[data-s2g-mobile-prev]');
    var next = nav.querySelector('[data-s2g-mobile-next]');
    var show = mediaItems.length > 1;
    nav.style.display = show ? '' : 'none';
    if (prev) prev.disabled = !show;
    if (next) next.disabled = !show;
    nav.setAttribute('data-s2g-active-index', String(activeIndex));
    gallery.setAttribute('data-s2g-active-index', String(activeIndex));
  }

  function switchActiveMedia(gallery, thumbItem, button) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbItem) return;

    var mediaId = thumbItem.getAttribute('data-target');
    var activeMedia = viewer.querySelector('[data-media-id="' + mediaId + '"]');
    if (!activeMedia) return;

    var mediaItems = getMediaItems(gallery);
    mediaItems.forEach(function (mediaItem) {
      mediaItem.classList.remove('is-active');
      mediaItem.style.display = 'none';
      mediaItem.setAttribute('aria-hidden', 'true');
    });

    activeMedia.classList.add('is-active');
    activeMedia.style.display = 'block';
    activeMedia.removeAttribute('aria-hidden');

    if (thumbnails) {
      thumbnails.querySelectorAll('.thumbnail').forEach(function (thumbButton) {
        thumbButton.removeAttribute('aria-current');
      });
      if (button) button.setAttribute('aria-current', 'true');

      var navigableThumbs = getNavigableThumbItems(gallery);
      var activeIndex = navigableThumbs.indexOf(thumbItem);
      if (activeIndex < 0) activeIndex = getThumbItems(thumbnails).indexOf(thumbItem);
      if (activeIndex > -1) {
        gallery.setAttribute('data-s2g-active-index', String(activeIndex));
        showThumbnailIndex(thumbnails, activeIndex);
      }
    } else {
      var viewerIndex = getNavigableMediaItems(gallery).indexOf(activeMedia);
      if (viewerIndex > -1) gallery.setAttribute('data-s2g-active-index', String(viewerIndex));
    }
    updateMobileNav(gallery);
  }

  function switchByIndex(gallery, index) {
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    var mediaItems = getNavigableMediaItems(gallery);
    if (!mediaItems.length) return;

    var normalized = ((index % mediaItems.length) + mediaItems.length) % mediaItems.length;

    if (thumbnails) {
      var thumbs = getNavigableThumbItems(gallery);
      var targetMedia = mediaItems[normalized];
      var targetId = targetMedia ? targetMedia.getAttribute('data-media-id') : '';
      var thumb = thumbs.find(function (item) { return item.getAttribute('data-target') === targetId; }) || thumbs[normalized];
      if (thumb) {
        var button = thumb.querySelector('button, .thumbnail');
        switchActiveMedia(gallery, thumb, button);
        gallery.setAttribute('data-s2g-active-index', String(normalized));
        updateMobileNav(gallery);
        return;
      }
    }

    getMediaItems(gallery).forEach(function (item) {
      item.classList.remove('is-active');
      item.style.display = 'none';
      item.setAttribute('aria-hidden', 'true');
    });

    mediaItems[normalized].classList.add('is-active');
    mediaItems[normalized].style.display = 'block';
    mediaItems[normalized].setAttribute('aria-hidden', 'false');
    gallery.setAttribute('data-s2g-active-index', String(normalized));
    updateMobileNav(gallery);
  }

  function bindPager(thumbnails) {
    if (!thumbnails) return;
    var items = getThumbItems(thumbnails);
    var prevButton = thumbnails.querySelector('.slider-button--prev');
    var nextButton = thumbnails.querySelector('.slider-button--next');

    thumbnails.classList.add('s2g-thumbnail-pager');
    thumbnails.s2gShowThumbnailIndex = function (index) { showThumbnailIndex(thumbnails, index); };

    if (prevButton && prevButton.dataset.s2gThumbPagerBound !== 'true') {
      prevButton.dataset.s2gThumbPagerBound = 'true';
      prevButton.setAttribute('type', 'button');
      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        updateThumbnailWindow(thumbnails, getCurrentStart(thumbnails) - 1);
      }, true);
    }

    if (nextButton && nextButton.dataset.s2gThumbPagerBound !== 'true') {
      nextButton.dataset.s2gThumbPagerBound = 'true';
      nextButton.setAttribute('type', 'button');
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        updateThumbnailWindow(thumbnails, getCurrentStart(thumbnails) + 1);
      }, true);
    }

    items.forEach(function (item, index) {
      var button = item.querySelector('button, .thumbnail');
      if (!button) return;
      button.setAttribute('type', 'button');
      button.addEventListener('click', function () {
        showThumbnailIndex(thumbnails, index);
      }, true);
    });

    var activeIndex = items.findIndex(function (item) {
      return !!item.querySelector('button[aria-current], .thumbnail[aria-current]');
    });
    updateThumbnailWindow(thumbnails, activeIndex > -1 ? Math.min(activeIndex, Math.max(0, items.length - MAX_VISIBLE_THUMBS)) : getCurrentStart(thumbnails));
  }

  function createMobileNav(gallery) {
    if (gallery.querySelector('.s2g-mobile-gallery-nav')) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var nav = document.createElement('div');
    nav.className = 's2g-mobile-gallery-nav';
    nav.innerHTML = '<button type="button" aria-label="Previous image" data-s2g-mobile-prev>‹</button><button type="button" aria-label="Next image" data-s2g-mobile-next>›</button>';
    gallery.appendChild(nav);
    nav.querySelector('[data-s2g-mobile-prev]').addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      switchByIndex(gallery, getActiveIndex(gallery) - 1);
    });
    nav.querySelector('[data-s2g-mobile-next]').addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      switchByIndex(gallery, getActiveIndex(gallery) + 1);
    });
  }


  function bindMobileSwipe(gallery) {
    if (gallery.dataset.s2gSwipeBound === 'true') return;
    gallery.dataset.s2gSwipeBound = 'true';
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var startX = 0;
    var startY = 0;
    viewer.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    viewer.addEventListener('touchend', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) switchByIndex(gallery, getActiveIndex(gallery) + 1);
      else switchByIndex(gallery, getActiveIndex(gallery) - 1);
    }, { passive: true });
  }

  function ensureLightbox() {
    var existing = document.querySelector('.s2g-gallery-lightbox');
    if (existing) return existing;
    var lightbox = document.createElement('div');
    lightbox.className = 's2g-gallery-lightbox';
    lightbox.innerHTML = '<div class="s2g-gallery-lightbox__panel" role="dialog" aria-modal="true" aria-label="Product image"><button type="button" class="s2g-gallery-lightbox__close" aria-label="Close image">×</button><button type="button" class="s2g-gallery-lightbox__prev" aria-label="Previous image">‹</button><img class="s2g-gallery-lightbox__image" alt=""><button type="button" class="s2g-gallery-lightbox__next" aria-label="Next image">›</button></div>';
    document.body.appendChild(lightbox);

    function close() {
      lightbox.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.classList.contains('s2g-gallery-lightbox__close')) close();
    });
    document.addEventListener('keydown', function (event) {
      if (!lightbox.classList.contains('is-open')) return;
      var state = lightbox.s2gState;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft' && state) openLightbox(state.gallery, state.index - 1);
      if (event.key === 'ArrowRight' && state) openLightbox(state.gallery, state.index + 1);
    });
    lightbox.querySelector('.s2g-gallery-lightbox__prev').addEventListener('click', function () {
      var state = lightbox.s2gState;
      if (state) openLightbox(state.gallery, state.index - 1);
    });
    lightbox.querySelector('.s2g-gallery-lightbox__next').addEventListener('click', function () {
      var state = lightbox.s2gState;
      if (state) openLightbox(state.gallery, state.index + 1);
    });
    return lightbox;
  }

  function getMediaImage(mediaItem) {
    return mediaItem ? mediaItem.querySelector('.product__media img, img') : null;
  }

  function openLightbox(gallery, index) {
    var mediaItems = getNavigableMediaItems(gallery);
    if (!mediaItems.length) return;
    var normalized = ((index % mediaItems.length) + mediaItems.length) % mediaItems.length;
    var mediaItem = mediaItems[normalized];
    var img = getMediaImage(mediaItem);
    if (!img) return;

    var lightbox = ensureLightbox();
    var lightboxImg = lightbox.querySelector('.s2g-gallery-lightbox__image');
    lightboxImg.src = img.currentSrc || img.src;
    lightboxImg.alt = img.alt || '';
    lightbox.s2gState = { gallery: gallery, index: normalized };
    lightbox.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function bindLightbox(gallery) {
    if (galleriesState.get(gallery)) return;
    galleriesState.set(gallery, true);

    gallery.addEventListener('click', function (event) {
      var mediaItem = event.target.closest('[id^="GalleryViewer"] [data-media-id]');
      var isImage = event.target.closest('.product__media img, .product__media-toggle, .cloud-zoom');
      if (!mediaItem || !isImage) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var mediaItems = getNavigableMediaItems(gallery);
      var index = mediaItems.indexOf(mediaItem);
      openLightbox(gallery, index > -1 ? index : getActiveIndex(gallery));
    }, true);
  }

  function initS2GProductGallery(root) {
    var galleries = (root || document).querySelectorAll('media-gallery');

    galleries.forEach(function (gallery) {
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (!viewer || !thumbnails) return;

      bindPager(thumbnails);
      createMobileNav(gallery);
      bindLightbox(gallery);
      bindMobileSwipe(gallery);

      getThumbItems(thumbnails).forEach(function (thumbItem) {
        var button = thumbItem.querySelector('button, .thumbnail');
        if (!button || button.dataset.s2gGalleryBound === 'true') return;
        button.dataset.s2gGalleryBound = 'true';
        button.setAttribute('type', 'button');

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          switchActiveMedia(gallery, thumbItem, button);
        }, true);
      });

      var mediaItems = getMediaItems(gallery);
      var firstActive = viewer.querySelector('.product__media-item.is-active') || viewer.querySelector('.product__media-item');
      if (firstActive) {
        mediaItems.forEach(function (item, i) {
          var active = item === firstActive;
          item.classList.toggle('is-active', active);
          item.style.display = active ? 'block' : 'none';
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) gallery.setAttribute('data-s2g-active-index', String(i));
        });
      }
      updateMobileNav(gallery);
    });
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[id^="GalleryThumbnails"] .slider-button--next, [id^="GalleryThumbnails"] .slider-button--prev');
    if (!arrow) return;
    var thumbnails = arrow.closest('[id^="GalleryThumbnails"]');
    if (!thumbnails) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var direction = arrow.classList.contains('slider-button--next') ? 1 : -1;
    updateThumbnailWindow(thumbnails, getCurrentStart(thumbnails) + direction);
  }, true);

  function init() { initS2GProductGallery(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { initS2GProductGallery(event.target); });
  window.addEventListener('load', init);
  window.addEventListener('resize', function () { initS2GProductGallery(document); });
})();
